import { SubscriptionService } from "../client"

/* ENDPOINTS */
export const getSettingsSubscriptions = () => {
    return {
        queryFn: async () => {
        const data = await SubscriptionService.readSubscription()
            return data ?? { data: null, count: 0 }
        },
        queryKey: ["settings-subscriptions"],
    }
}